// ImpactTable.js

const ImpactTable = ({ assessments, fieldOptions }) => {
  // Считаем статистику по Impact

  const assessmentsByType = {};

  // Инициализируем маппинг для каждого option_value
  fieldOptions.forEach(option => {
    assessmentsByType[option.option_value] = [];
  });
  // Распределяем оценки по типам
  assessments.forEach(assessment => {
    const assessmentType = assessment.impact;
    if (assessmentType && assessmentsByType[assessmentType]) {
      assessmentsByType[assessmentType].push(assessment);
    }
  });

  // Формируем статистику из маппинга
  const stats = Object.entries(assessmentsByType).map(([optionValue, assessmentsList]) => {
    // Находим соответствующий option_text
    const option = fieldOptions.find(opt => opt.option_value === optionValue);
    const reportType = option ? option.option_text : optionValue;

    const totalCount = assessmentsList.length;

    // Считаем количество критериев с score = 0
    const zeroScoreCount = assessmentsList.reduce((count, assessment) => {
      if (assessment.items && Array.isArray(assessment.items)) {
        return count + assessment.items.filter(item => item.score === 0).length;
      }
      return count;
    }, 0);

    const percentage = totalCount > 0 ? ((zeroScoreCount / totalCount) * 100).toFixed(1) : '0.0';

    return {
      reportType,
      totalCount,
      zeroScoreCount,
      percentage
    };
  });

  // Добавляем "Без типа" если есть оценки без типа
  const assessmentsWithoutType = assessments.filter(a => !a.impact);
  if (assessmentsWithoutType.length > 0) {
    const zeroScoreCount = assessmentsWithoutType.reduce((count, assessment) => {
      if (assessment.items && Array.isArray(assessment.items)) {
        return count + assessment.items.filter(item => item.score === 0).length;
      }
      return count;
    }, 0);

    const percentage = assessmentsWithoutType.length > 0 ?
      ((zeroScoreCount / assessmentsWithoutType.length) * 100).toFixed(1) : '0.0';

    stats.push({
      reportType: 'Без типа',
      totalCount: assessmentsWithoutType.length,
      zeroScoreCount,
      percentage
    });
  }

  const sortedStats = stats.sort((a, b) => b.totalCount - a.totalCount);

  return (
    <div className="table-wrapper">
      <h3>Статистика по Impact</h3>
      <table className="stats-table">
        <thead>
        <tr>
          <th>Impact</th>
          <th>Количество проверок</th>
          <th>Количество ошибок</th>
          <th>% ошибок</th>
        </tr>
        </thead>
        <tbody>
        {sortedStats.map((stat) => (
            <tr key={stat.reportType}>
              <td>{stat.reportType}</td>
              <td>{stat.totalCount}</td>
              <td>{stat.zeroScoreCount}</td>
              <td>{stat.percentage}%</td>
            </tr>
        ))}
        {sortedStats.length === 0 && (
            <tr>
              <td colSpan="3" style={{textAlign: 'center'}}>Нет данных для отображения</td>
            </tr>
        )}
        </tbody>
        <tfoot>
          <tr>
            <td>Total</td>
            <td>{sortedStats.reduce((sum, stat) => sum + stat.totalCount, 0)}</td>
            <td>{sortedStats.reduce((sum, stat) => sum + stat.zeroScoreCount, 0)}</td>
            <td>{
              sortedStats.length > 0
                  ? ((sortedStats.reduce((sum, stat) => sum + stat.zeroScoreCount, 0) / sortedStats.reduce((sum, stat) => sum + stat.totalCount, 0)) * 100).toFixed(1)
                  : '0.0'
            }%
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default ImpactTable;